export default __webpack_public_path__ + "static/media/slide27.8ed73b28.jpg";